import API from './AplicationService';
import { handleError, showWarnMessage } from '../utils/Utility';

export async function Authenticate(email, password, administrativeCompanyId, reminder) {
	let login = {
		email: email,
		password: password,
		administrativeCompanyId: administrativeCompanyId,
		reminder: reminder,
	};
	return API.post('account/SignIn', login)
		.then(response => {
			let authenticationInfo = JSON.stringify(response.data);
			localStorage.setItem('authentication', authenticationInfo);
			return true;
		})
		.catch(error => {
			handleError(error);
			return false;
		});
}
export async function Logout() {
	return API.post('account/SignOut')
		.then(response => {
			localStorage.removeItem('authentication');
			return true;
		})
		.catch(error => {
			localStorage.removeItem('authentication');
			return true;
		});
}
export function GetAuthentication(checkExpiration = true) {
	let localAuthentication = localStorage.getItem('authentication');
	if (localAuthentication) {
		let authentication = JSON.parse(localAuthentication);
		if (checkExpiration) {
			if (authentication.expiredOn) {
				var expiration = Date.parse(authentication.expiredOn);
				var currentDate = Date.now();
				if (expiration > currentDate) {
					if (authentication.token) {
						return authentication;
					} else {
						return null;
					}
				} else {
					return null;
				}
			} else {
				return null;
			}
		} else {
			if (authentication.token) {
				return authentication;
			} else {
				return null;
			}
		}
	} else {
		return null;
	}
}
export function IsLoggedIn() {
	try {
		var authentication = GetAuthentication();
		if (authentication) {
			return true;
		} else {
			return false;
		}
	} catch {
		return false;
	}
}
